export default Object.freeze({
    Archived: -1,
    Editing: 0,
    Submitted: 1,
    Flagged: 2,
    Approved: 3,
})
